var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewDataIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.698,
    height: 83.698,
    viewBox: "0 0 83.698 83.698",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#bce0fd;}.b{fill:#ffcbbe;}.c{fill:#1a8cff;}.d{fill:#0062f4;}.e{fill:#0063f6;}.f{fill:#00429a;}.g{fill:#013272;}.h{fill:#ffddcf;}.i{fill:#a3d8ff;}.j{fill:#b9e1ff;}.k{fill:#88c7f7;}.l{fill:#ffbead;}.m{fill:#ffd6cc;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,41.849A41.849,41.849,0,1,0,41.849,0,41.854,41.854,0,0,0,0,41.849Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.915 -0.395)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.533 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M74.491,326.151l-41.241-.088.578-7.927a10.454,10.454,0,0,1,8.812-9.569l3.324-.521a3.468,3.468,0,0,0,2.934-3.428v-12.2H61.368v12.2a3.47,3.47,0,0,0,2.934,3.428l3.325.521a10.453,10.453,0,0,1,8.81,9.569l.012,6.507C76.52,325.61,74.491,326.151,74.491,326.151Z",
    transform: "translate(-29.769 -247.612)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M75.129,411.237s-6.331,5.459-20.06,5.582-21.819-5.568-21.819-5.568l.578-7.927a10.454,10.454,0,0,1,8.812-9.569l3.324-.521a3.58,3.58,0,0,0,.68-.178,11.611,11.611,0,0,0,16.886-.036,3.485,3.485,0,0,0,.772.214l3.325.521a10.453,10.453,0,0,1,8.81,9.569l.462,6.786Z",
    transform: "translate(-29.769 -332.799)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M47.25,400.055h5.239a5.14,5.14,0,0,0,4.835-3.4,11.832,11.832,0,0,1-2.255.219,11.444,11.444,0,0,1-8.426-3.623c-2.008.745-6.184.05-9.768,3.623l-3.561,13.7-.064.871,5.778,2.844,2.912.969L46.03,401A1.26,1.26,0,0,1,47.25,400.055Z",
    transform: "translate(-29.769 -332.997)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M238.01,410.173l-.487-6.849A10.431,10.431,0,0,0,234.787,397c-3.585-3.894-8.037-3.237-10.005-3.919l-.023-.008c-.049-.017-.1-.035-.145-.054a11.018,11.018,0,0,1-1.13,1.066l.906.142a10.453,10.453,0,0,1,8.81,9.569l.447,6.137c.037.514.124,2.883.124,2.883l2.534-1.566Z",
    transform: "translate(-190.855 -332.799)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M257.254,464.978a1.184,1.184,0,0,0-1.184,1.184v9.794l2.368-.8v-8.994A1.184,1.184,0,0,0,257.254,464.978Z",
    transform: "translate(-218.448 -393.732)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M44.729,34.4H39.437a16.542,16.542,0,0,0-14.382,8.357,9.026,9.026,0,0,0-6.725,8.989l.457,15.809h46.3V54.764A20.363,20.363,0,0,0,44.729,34.4Z",
    transform: "translate(-17.133 -29.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M39.437,34.4a16.542,16.542,0,0,0-14.382,8.357,9.026,9.026,0,0,0-6.725,8.989l.457,15.809L36.6,51.747,34.26,40.665Z",
    transform: "translate(-17.133 -29.13)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 18.09)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.235,222.811H14.079a3.546,3.546,0,0,1-3.546-3.546v-1.112a3.546,3.546,0,0,1,3.546-3.546h8.156Z",
    transform: "translate(-10.533 -199.814)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M258.22,222.811h8.156a3.546,3.546,0,0,0,3.546-3.546v-1.112a3.546,3.546,0,0,0-3.546-3.546H258.22Z",
    transform: "translate(-220.268 -199.814)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M91.1,135.605c0,11.688-11.791,18.4-18.68,18.4s-18.68-6.709-18.68-18.4c0-7.466,2.075-13.116,5.433-16.906a1.9,1.9,0,0,1,2.841.01,25.289,25.289,0,0,0,2.456,2.453,5.931,5.931,0,0,0,3.625,1.718,2.886,2.886,0,0,0,2.346-1.207,1.494,1.494,0,0,1,1.873-.483,38.287,38.287,0,0,0,13.963,3.548A4.372,4.372,0,0,1,90.3,128.1,33.2,33.2,0,0,1,91.1,135.605Z",
    transform: "translate(-47.118 -118.065)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M111.883,166.213a4.357,4.357,0,0,0-2.873-3.14,34.63,34.63,0,0,1,.647,6.857c0,11.935-12.041,18.786-19.075,18.786a20.326,20.326,0,0,1-11.349-4.27c4.054,4.964,10.4,7.669,14.774,7.669,6.889,0,18.68-6.709,18.68-18.4A33.191,33.191,0,0,0,111.883,166.213Z",
    transform: "translate(-68.706 -138.086)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-127.686 -184.959)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 4,
    height: 25,
    rx: 2,
    transform: "translate(142.271 225.469) rotate(16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M12.917,0A12.917,12.917,0,1,1,0,12.917,12.917,12.917,0,0,1,12.917,0Z",
    transform: "translate(133.088 204.836)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 9.038,
    cy: 9.038,
    r: 9.038,
    transform: "translate(136.967 208.715)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M112.428,231.311A9.038,9.038,0,0,1,105.1,216.98,9.038,9.038,0,1,0,117.721,229.6,9,9,0,0,1,112.428,231.311Z",
    transform: "translate(35.61 -6.554)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 10,
    height: 25,
    rx: 3,
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 137.099, 231.232)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M46.03,315.621a1.26,1.26,0,0,1,1.219-.943h5.239a5.138,5.138,0,0,0,5.138-5.138v-2.16a.916.916,0,0,1,.916-.916H61.9a3.455,3.455,0,0,1-.53-1.838V301l-16.818,1.169c-.589,0,5.974-1.825,6.313-2.307.659-1.664-4.59,1.376-5.172-.27-.455-1.322,3.636-7.177,3.207-7.055l-3.91,4.772,3.91,7.32a3.468,3.468,0,0,1-2.934,3.428l-3.324.521a10.436,10.436,0,0,0-5.765,2.924l-2.167,7.51v.664s2.653,2.488,4.8,4.088a21.164,21.164,0,0,0,3.8,2.311Z",
    transform: "translate(-39.769 -247.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M22.3,309.425l3.327-11.165a1.27,1.27,0,0,1,1.23-.951h5.231a5.138,5.138,0,0,0,5.138-5.138v-2.16a.916.916,0,0,1,.916-.916h5.107a2.779,2.779,0,0,0,2.8-2.71,2.733,2.733,0,0,0-2.734-2.758H29.953a.727.727,0,0,1-.6-1.145l2.208-3.154a2.681,2.681,0,0,0-.619-3.7l-.056-.041a2.762,2.762,0,0,0-3.869.61c-1.577,2.187-8.51,11.785-9.195,12.735L14.367,301.97a7.966,7.966,0,0,0,2.375,2.848C18.76,306.586,22.3,309.425,22.3,309.425Z",
    transform: "translate(-22.054 -232.912)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewDataIcon);
export default __webpack_public_path__ + "static/media/review-data-icon.cd1ec5a48cff70986ee2fd8e0535b256.svg";
export { ForwardRef as ReactComponent };